export { default } from './LandingPageDetailsSection'
